/* favourites-page.js — <sf-favourites-page>: hydrates the saved list (theme.favourites, device-local) into real
   product cards via the Section Rendering API (GET /products/<handle>?section_id=card-fetch → article.card-b).
   Skeleton cards while loading, remove buttons, live count, empty state. Requires theme.js. */
'use strict';
(function () {
  const theme = window.theme || (window.theme = {});
  class SFFavouritesPage extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      this.grid = this.querySelector('[data-favs-grid]');
      this.empty = this.querySelector('[data-favs-empty]');
      this.status = this.querySelector('[data-favs-status]');
      this.skeletonTpl = this.querySelector('template[data-favs-skeleton]');
      this.removeTpl = this.querySelector('template[data-favs-remove]');
      this.errorTpl = this.querySelector('template[data-favs-error]');
      this.max = parseInt(this.dataset.max, 10) || 24;
      this.fetchUrl = this.dataset.fetchUrl || '/products/';
      this.sectionId = this.dataset.section || 'card-fetch';
      this.cache = new Map();
      this.render();
      this._unsub = theme.pubsub ? theme.pubsub.subscribe('favourites:change', () => this.render()) : null;
      this.addEventListener('click', (e) => {
        const btn = e.target.closest('.fav-remove');
        if (!btn) return;
        e.preventDefault();
        const card = btn.closest('[data-handle]');
        if (card && theme.favourites) theme.favourites.toggle(card.dataset.handle);
      });
    }
    disconnectedCallback() { if (this._unsub) this._unsub(); }
    list() {
      const l = theme.favourites && typeof theme.favourites.list === 'function' ? theme.favourites.list() : [];
      return (Array.isArray(l) ? l : []).map((f) => (typeof f === 'string' ? { handle: f } : f)).filter((f) => f && f.handle).slice(0, this.max);
    }
    announce(n) {
      if (!this.status) return;
      const tpl = n === 1 ? this.dataset.strCountOne : this.dataset.strCountOther;
      this.status.textContent = (tpl || '[count]').replace('[count]', String(n));
    }
    async render() {
      const items = this.list();
      const seq = (this._seq = (this._seq || 0) + 1);
      this.toggleAttribute('data-has-favs', items.length > 0);
      if (this.empty) this.empty.hidden = items.length > 0;
      if (!this.grid) return;
      this.grid.hidden = items.length === 0;
      this.announce(items.length);
      if (!items.length) { this.grid.replaceChildren(); this.grid.removeAttribute('aria-busy'); return; }
      /* Keep already-rendered cards, add skeletons for new handles, drop removed ones. */
      const existing = new Map();
      Array.from(this.grid.children).forEach((el) => { if (el.dataset.handle) existing.set(el.dataset.handle, el); });
      const frag = document.createDocumentFragment();
      const pending = [];
      items.forEach((f) => {
        let el = existing.get(f.handle);
        if (!el) {
          el = this.skeletonTpl ? this.skeletonTpl.content.firstElementChild.cloneNode(true) : document.createElement('article');
          el.dataset.handle = f.handle;
          pending.push({ handle: f.handle, el });
        }
        frag.appendChild(el);
      });
      this.grid.replaceChildren(frag);
      if (!pending.length) { this.grid.removeAttribute('aria-busy'); return; }
      this.grid.setAttribute('aria-busy', 'true');
      await Promise.all(pending.map((p) => this.hydrate(p, seq)));
      if (seq === this._seq) this.grid.removeAttribute('aria-busy');
    }
    async hydrate({ handle, el }, seq) {
      try {
        let card = this.cache.get(handle);
        if (!card) {
          const url = this.fetchUrl + encodeURIComponent(handle) + '?section_id=' + encodeURIComponent(this.sectionId);
          const html = await theme.fetchText(url, { headers: { Accept: 'text/html' } });
          const content = theme.sectionHtml(html, this.sectionId, { inner: true });
          card = content && (content.matches && content.matches('.card-b') ? content : content.querySelector('.card-b'));
          if (!card) throw new Error('favourites: card not found for ' + handle);
          this.cache.set(handle, card);
        }
        if (seq !== this._seq || !el.isConnected) return;
        const clone = card.cloneNode(true);
        clone.dataset.handle = handle;
        clone.classList.add('favs-card');
        if (this.dataset.showActions === 'false') { const acts = clone.querySelector('.card-acts'); if (acts) acts.remove(); }
        if (this.removeTpl) {
          const media = clone.querySelector('.card-b__media') || clone;
          media.style.position = media.style.position || 'relative';
          media.appendChild(this.removeTpl.content.firstElementChild.cloneNode(true));
        }
        el.replaceWith(clone);
      } catch (err) {
        if (seq !== this._seq || !el.isConnected) return;
        const note = document.createElement('article');
        note.className = 'card-b card-b--grid favs-card favs-card--error';
        note.dataset.handle = handle;
        const p = document.createElement('p');
        p.className = 'favs-note favs-note--error';
        p.textContent = this.dataset.strUnavailable || this.dataset.strError || 'Unavailable';
        note.appendChild(p);
        if (this.removeTpl) note.appendChild(this.removeTpl.content.firstElementChild.cloneNode(true));
        el.replaceWith(note);
        console.warn(err);
      }
    }
  }
  if (!customElements.get('sf-favourites-page')) customElements.define('sf-favourites-page', SFFavouritesPage);
})();
